export default {
  styleOverrides: {
    root: {
      flexGrow: 1,
    },
  },
};
